<template>
  <div class="chat-index">
    <app-view-layout
      header="Chat"
      :subheader="getMessagesCount"
    >
      <template #toolbarMenu>
        <v-btn
          text
          color="primary"
          :disabled="!unreadMessagesCount"
          @click="markAllRead"
        >
          Oznacz wszystkie jako przeczytane
        </v-btn>
      </template>
      <template
        v-if="channelsList.length"
        #content
      >
        <v-row>
          <v-col
            cols="12"
            md="4"
            xl="3"
          >
            <ChatChannelsList
              :channels="displayedChannelsList"
              :project-id="projectId"
            />
          </v-col>

          <v-col
            cols="12"
            md="8"
            xl="9"
          >
            <v-card
              v-if="isIndexRoute"
              class="chat-index__empty"
            >
              <img src="@/assets/img/empty-chat.svg">
              <h2>
                Wybierz kanał projektowy
              </h2>
              <p>
                Aby wyświetlić chat projektowy należy wybrać
                jeden z kanałów znajdujących się po lewej stronie.
              </p>
            </v-card>

            <router-view
              v-else
              :key="$route.params.channelId"
            />
          </v-col>
        </v-row>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import utils from '@/helpers/utils';
import { mapState, mapGetters, mapActions } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import ChatChannelsList from '@/components/Chat/ChatChannelsList.vue';

export default {
  props: {
    projectId: {
      type: [Number, String],
      default: null,
    },
  },

  components: {
    AppViewLayout,
    ChatChannelsList,
  },

  computed: {
    ...mapState('chat', [
      'channelsList',
    ]),
    ...mapGetters('chat', [
      'unreadMessagesCount',
    ]),

    displayedChannelsList() {
      if (this.projectId) {
        return new Array(this.channelsList
          .find((channel) => channel.projectId === parseInt(this.projectId, 10)));
      }
      return this.channelsList.filter((channel) => !channel.archived);
    },

    getMessagesCount() {
      return utils.getCounterWithSuffix(this.unreadMessagesCount,
        'nowa wiadomość', 'nowe wiadomości', 'nowych wiadomości');
    },

    isIndexRoute() {
      return this.$route.name === 'chat-index';
    },
  },

  created() {
    this.fetchChannels();
  },

  methods: {
    ...mapActions('chat', [
      'fetchChannels',
      'markAllRead',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.chat-index {
  &__empty {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      margin-bottom: 16px;
    }
    h2 {
      font-weight: 500;
      font-size: 15px;
      line-height: 20px;
      margin-bottom: 16px;
    }
    p {
      font-size: 12px;
      line-height: 18px;
      max-width: 320px;
      text-align: center;
    }
  }
}
</style>
